import { useEffect, useState } from 'react';

/** The mockup's desktop frame, as a width (see scripts/port-mockup-css.mjs). */
export const DESKTOP_QUERY = '(min-width: 900px)';

export function useDesktop(): boolean {
  const media = typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(DESKTOP_QUERY) : null;
  const [desktop, setDesktop] = useState(media?.matches ?? false);
  useEffect(() => {
    if (!media) return;
    const on = (e: MediaQueryListEvent) => setDesktop(e.matches);
    media.addEventListener('change', on);
    return () => media.removeEventListener('change', on);
  }, [media]);
  return desktop;
}
